import { useState } from 'react';
import { quoteByCode, opsErr, okCode } from '../../api/ops';
import { OpsGate, ScanSearch, QuoteDetail, useOps } from './opsCommon';

// Tra cứu đơn hàng theo mã (nhập / quét) -> chi tiết đơn + ảnh (Trang chủ app "i love GTS").
function Lookup() {
  const account = useOps();
  const [q, setQ] = useState('');
  const [busy, setBusy] = useState(false);
  const [quote, setQuote] = useState(null);
  const [err, setErr] = useState('');

  const search = async (code) => {
    if (!code) return;
    setBusy(true);
    setErr('');
    try {
      const d = await quoteByCode(code);
      if (okCode(d) && d.data) setQuote(d.data);
      else { setQuote(null); setErr('Không tìm thấy đơn hàng'); }
    } catch (e) {
      setQuote(null);
      setErr(opsErr(e, 'Không tìm thấy đơn hàng'));
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      <ScanSearch value={q} onChange={setQ} onSubmit={search} busy={busy} placeholder="Mã đơn / mã tracking…" autoFocus />
      {busy && <div className="empty">Đang tìm…</div>}
      {!busy && err && <div className="empty">{err}</div>}
      {!busy && quote && <QuoteDetail quote={quote} base={account.base} />}
    </>
  );
}

export default function OpsLookupPage({ onBack }) {
  return (
    <OpsGate onBack={onBack} title="Tra cứu đơn hàng" sub="Nhập hoặc quét mã để xem thông tin và hình ảnh đơn">
      <Lookup />
    </OpsGate>
  );
}
